import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHome, faTasks, faIdCardAlt, faSkullCrossbones, faChartBar, faSlidersH, faSignOutAlt, faAppleAlt } from '@fortawesome/free-solid-svg-icons'
import { Link } from "react-router-dom";
import VIf from './ui/VIf.js';
import api from '../api/index.js';
import './Menu.scss';


class Menu extends Component {
	
	render() {
		if (api.isdev()) {
			return <div className="Menu">
					<ul>
						<li><Link to="/" title="Dashboard"><FontAwesomeIcon icon={faHome}/></Link></li>
						<VIf iff={api.auth.hasPermission('employees')}><li><Link to="/attendance" title="Attendance"><FontAwesomeIcon icon={faTasks}/></Link></li></VIf>
						<VIf iff={api.auth.hasPermission('employees')}><li><Link to="/employees" title="Employees"><FontAwesomeIcon icon={faIdCardAlt}/></Link></li></VIf>
						<li><Link to="/" title="Sprays"><FontAwesomeIcon icon={faSkullCrossbones}/></Link></li>
						<li><Link to="/processors" title="Processors"><FontAwesomeIcon icon={faAppleAlt}/></Link></li>
						<li><Link to="/" title="Reports"><FontAwesomeIcon icon={faChartBar}/></Link></li>
						<li><Link to="/" title="Settings"><FontAwesomeIcon icon={faSlidersH}/></Link></li>
						<li><Link to="/logout" title="Sign out"><FontAwesomeIcon icon={faSignOutAlt}/></Link></li>
					</ul>
				</div>;
		} else {
			return <div className="Menu">
					<ul>
						<li><Link to="/" title="Dashboard"><FontAwesomeIcon icon={faHome}/></Link></li>
						<VIf iff={api.auth.hasPermission('employees')}><li><Link to="/attendance" title="Attendance"><FontAwesomeIcon icon={faTasks}/></Link></li></VIf>
						<VIf iff={api.auth.hasPermission('employees')}><li><Link to="/employees" title="Employees"><FontAwesomeIcon icon={faIdCardAlt}/></Link></li></VIf>
						<li><Link to="/processors" title="Processors"><FontAwesomeIcon icon={faAppleAlt}/></Link></li>
						<li><Link to="/logout" title="Sign out"><FontAwesomeIcon icon={faSignOutAlt}/></Link></li>
					</ul>
				</div>;

		}
	}
}

export default Menu;